import React, { RefObject } from "react";

import { ContentListProps, ContentListState } from "./models";

//import "./style.scss"
import { ContentPreviewElement } from "../../../content-preview-element/content-preview-element";


export class ContentList extends React.Component<ContentListProps, ContentListState> {

    private carouselRef: RefObject<HTMLDivElement> = React.createRef();;

    scrollLeft() {

        console.log("Scroll left");

        this.carouselRef.current!.scroll({
            top: 0,
            left: (this.carouselRef.current!.scrollLeft - 700),
            behavior: "smooth"
        });

        console.log(this.carouselRef.current!.scrollLeft)
    }

    scrollRight() {

        console.log("Scroll right");

        this.carouselRef.current!.scroll({
            top: 0,
            left: (this.carouselRef.current!.scrollLeft + 700),
            behavior: "smooth"
        });

        console.log(this.carouselRef.current!.scrollLeft)
    }

    render() {
        return (
            <div ref={this.carouselRef} className="cl-main" id={"carousel" + this.props.carouselId} style={{
                display: "flex",
                position: "relative",
                flexDirection: "row",
            }}>
                {this.props.contentList.contents.map(
                    (item) => (
                        <>
                            <ContentPreviewElement hasHorizontalMargin content={item} key={item.id+"_"+Math.random()} overlayId={'overlay' + item.id} />
                        </>
                    ))}
            </div>);
    }
}
